/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type co_getplato_grid_sales_features_draft_defaultheader_Request = {
    customer_id: string;
    sales_order_type: co_getplato_grid_sales_features_draft_defaultheader_Request.sales_order_type;
    clerk_id: string;
    external?: Record<string, any>;
};
export namespace co_getplato_grid_sales_features_draft_defaultheader_Request {
    export enum sales_order_type {
        ORDER = 'ORDER',
        QUOTE = 'QUOTE',
        CREDIT_NOTE = 'CREDIT_NOTE',
    }
}

